<template>
    <el-checkbox-group
        class="base-checkbox-group"
        data-testid="input-checkbox-group"
        :size="size"
        v-bind="attrs"
        v-on="listeners"
    >
        <slot />
    </el-checkbox-group>
</template>

<script setup lang="ts">
import { CheckboxGroup as ElCheckboxGroup } from 'element-ui'
import { useAttrs, useListeners } from 'vue'

const listeners = useListeners()
const attrs = useAttrs()

withDefaults(
    defineProps<{
        size?: 'medium' | 'small' | 'mini'
    }>(),
    {
        size: 'small'
    }
)
</script>
